import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
var css = {
  "PopOver": "rui-DK6Uv",
  "icon": "rui-E3NJj",
  "children": "rui-SxgRL"
};
import IconButton from '../IconButton/IconButton';
import classNames from 'classnames';
import { escKeyCode } from '../constants/keyboardKeys';
var PopOver = /*#__PURE__*/function (_React$Component) {
  _inherits(PopOver, _React$Component);
  var _super = _createSuper(PopOver);
  function PopOver() {
    var _this;
    _classCallCheck(this, PopOver);
    _this = _super.apply(this, arguments);
    _this.unregisterListeners = function () {
      document.removeEventListener('keydown', _this.escKey, false);
      document.removeEventListener('mousedown', _this.handleEvent, false);
      document.removeEventListener('touchstart', _this.handleEvent, false);
    };
    _this.registerListeners = function () {
      document.addEventListener('keydown', _this.escKey, false);
      document.addEventListener('mousedown', _this.handleEvent, false);
      document.addEventListener('touchstart', _this.handleEvent, false);
    };
    _this.handleEvent = function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (_this.popOverNode && !_this.popOverNode.contains(event.target)) {
        _this.props.onToggle()(event);
      }
    };
    _this.escKey = function (evt) {
      if (evt.keyCode === escKeyCode) {
        _this.props.onToggle()(evt);
      }
    };
    return _this;
  }
  _createClass(PopOver, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.open !== prevProps.open) {
        if (this.props.open) {
          this.registerListeners();
        } else {
          this.unregisterListeners();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unregisterListeners();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/React.createElement("div", {
        className: css.PopOver,
        ref: function ref(node) {
          _this2.popOverNode = node;
        }
      }, /*#__PURE__*/React.createElement(IconButton, {
        className: classNames('icon-more', css.icon),
        icon: "icon-more",
        name: "More",
        onClick: this.props.onToggle(true)
      }), this.props.open && /*#__PURE__*/React.createElement("div", {
        className: css.children
      }, this.props.children));
    }
  }]);
  return PopOver;
}(React.Component);
PopOver.defaultProps = {
  open: false,
  onToggle: function onToggle() {
    return function () {};
  }
};
export default PopOver;